<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cXRAtr/tc-custom/9781504057516.jpg?1697125538394" alt="This image is the cover for the book Sunburned Corpse, The PI Steve Conacher Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sunburned Corpse, The PI Steve Conacher Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>It’s a heady cocktail of business, pleasure, and murder for Manhattan PI Steve Conacher, who’s cruising into danger in the Caribbean.</b><br/>  <br/> When popular cartoonist Lawrence Lariar decided to moonlight as a mystery writer, creating comic book artist turned amateur sleuth Homer Bull was a natural. From the 1940s through the 1960s, Lariar continued to switch from sketching caricatures to sketchy characters, writing hardboiled crime fiction under his own name as well as the pseudonyms Michael Stark, Adam Knight, Michael Lawrence, and Marston La France, and creating a series of memorable gumshoes. Now his classic whodunits are available as ebooks.<br/>  <br/> For New York private dick and landlubber Steve Conacher, it’s a dream assignment: a free cruise to tropical San Juan to skip trace a budding young artist and runaway heiress. So far, the hunt for Nancy Scott is a pleasure—especially when his first contact is paradise incarnate. She’s smart, sexy, clever, and goes down as easy as a shot of aquavit. She’s also ready and willing to help Conacher on his search. Maybe that’s why somebody just throttled the fun-loving adventuress to death.<br/>  <br/> Now Conacher is looking into a murder, too. When his colliding investigations lead to a mysterious art gallery in Puerto Rico, run by a half-blind painter, Conacher learns just how deeply involved he is in the sun-kissed secrets of two women—one missing, one dead—that are beginning to threaten his own life.<br/>  <br/> The Sunburned Corpse <i>is the 4th book in the PI Steve Conacher Mysteries, but you may enjoy reading the series in any order.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lawrence Lariar
      </h2>
      
      <p class="authorDescription body article">Lawrence Lariar (1908&ndash;1981) was an American novelist, cartoonist and cartoon editor, known for his <I>Best Cartoons of the Year</I> series of cartoon collections. He wrote crime novels, sometimes using the pseudonyms Michael Stark, Adam Knight and Marston la France.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress/Open Road
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24e0c02c